import Vue from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import wx from "jweixin-module"
import 'vant/lib/index.css'

Vue.use(Vant)
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
// 分页组件
import Pagination from '@/components/Pagination'
// 自定义表格工具组件
import RightToolbar from '@/components/RightToolbar'
// 富文本组件
import Editor from '@/components/Editor'
// 文件上传组件
import FileUpload from '@/components/FileUpload'
import FileUpload1 from '@/components/FileUpload1'
// 图片上传组件
import ImageUpload from '@/components/ImageUpload'
// 图片预览组件
import ImagePreview from '@/components/ImagePreview'
import './style/element-variables.scss'
import '@/style/common.css' // global css
// import "font-awesome/css/font-awesome.css"
import Cookies from 'js-cookie'
// import BaiduMap from 'vue-baidu-map'
// import { BmlMarkerClusterer } from 'vue-baidu-map'
// import { parseTime } from '@/utils/parseTime'`
import '@/assets/iconfont/iconfont.css'
import Ellipsis from '@/components/common/Ellipsis'
import WDialog from '@/components/common/WDialog'
import Tip from '@/components/common/Tip'
// 在入口文件中（main.js），导入组件库
import VueHashCalendar from 'vue-hash-calendar'
// 引入组件CSS样式
import 'vue-hash-calendar/lib/vue-hash-calendar.css'
import { download, downloadData } from '@/utils/request'
// 注册组件库
Vue.use(VueHashCalendar)
require("@/utils/CustomUtil");
import {
  parseTime,
  resetForm,
  addDateRange,
  selectDictLabel,
  selectDictLabels,
  handleTree,
} from '@/utils/ruoyi'
import axios from 'axios'
//将axios挂载到原型上
Vue.prototype.$axios = axios
//配置全局的axios默认值（可选）

// axios.defaults.baseURL = 'https://aip.baidubce.com'
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'
// Vue.component('blm-marker-cluster', BmlMarkerClusterer)
Vue.use(Ellipsis)
Vue.use(WDialog)
Vue.use(Tip)
// Vue.use(BaiduMap, {
//   ak: 'Liz5cx8NFb67bi5f97L81wjBufDzl6ew',
// })

Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
})
// 全局方法挂载
Vue.prototype.$wx = wx
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.handleTree = handleTree
Vue.prototype.download = download
Vue.prototype.downloadData = downloadData
Vue.component('Pagination', Pagination)
Vue.component('RightToolbar', RightToolbar)
Vue.component('Editor', Editor)
Vue.component('FileUpload', FileUpload)
Vue.component('FileUpload1', FileUpload1)
Vue.component('ImageUpload', ImageUpload)
Vue.component('ImagePreview', ImagePreview)
import VueQuillEditor from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.use(VueQuillEditor, {
  placeholder: '请输入内容',
})
Vue.config.productionTip = false
// Vue.prototype.$host = '/baidu'
Vue.prototype.$isNotEmpty = function (obj) {
  return obj !== undefined && obj !== null && obj !== '' && obj !== 'null'
}

Vue.prototype.$getDefalut = function (obj, key, df) {
  return obj === undefined || key === undefined || !this.$isNotEmpty(obj[key])
    ? df
    : obj[key]
}

Vue.prototype.$deepCopy = function (obj) {
  return JSON.parse(JSON.stringify(obj))
}
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
